import React from 'react'

function ViewSaller({ user, closeModal }) {
  if (!user) return null;
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const BASE_URL = process.env.REACT_APP_URL;
  const { date, time } = formatDateTime(user?.createdAt);

  const isHomeAddress = user?.addressType === 'Home';
  const isOfficeAddress = user?.addressType === 'Office';
  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="manufacturerModal"> Seller Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body px-5">
            <div className="d-box mt-3 pt-1">
              <ul className="d-flex list-unstyled justify-content-between">
                {/* <li><span>sallerType: </span>{user?.deviceType}</li> */}
                <li><strong>Name:</strong> {`${user?.firstName || "N/A"} ${user?.lastName || ""}`.trim() || "N/A"}</li>
                <li><strong>Mobile No:</strong> {user?.mobileNo || "N/A"}</li>
                <li><strong>Email:</strong> {user?.email || "N/A"}</li>
                <li><strong>State:</strong> {user?.stateName || "N/A"}</li>
                <li><strong>City:</strong> {user?.cityName || "N/A"}</li>
                <li><strong>Address:</strong> {user?.address || "N/A"}</li>
                <li><strong>Registration Date:</strong> {date}</li>
              <li>
  <strong>Image:</strong>
  {user?.image ? (
    <img
      src={`${BASE_URL}${user.image}`} 
      alt="Seller"
      style={{
        width: '80px',
        height: '80px',
        borderRadius: '8px',
        marginLeft: '10px'
      }}
    />
  ) : "N/A"}
</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewSaller